import {
    TDP_EMPLOYEE_MASTER_LIST_LOG_CREATE,
    TDP_EMPLOYEE_MASTER_LIST_LOG_CREATE_FAIL,
    TDP_EMPLOYEE_MASTER_LIST_LOG_CREATE_SUCCESS,
    RESET,
    RESET_TDP_EMPLOYEE_MASTER_LIST_LOG_CREATE,
    GET_TDP_EMPLOYEE_MASTER_LIST_LOG_DETAILS,
    GET_TDP_EMPLOYEE_MASTER_LIST_LOG_DETAILS_SUCCESS,
    GET_TDP_EMPLOYEE_MASTER_LIST_LOG_DETAILS_FAIL,
    UPDATE_TDP_EMPLOYEE_MASTER_LIST_LOG,
    UPDATE_TDP_EMPLOYEE_MASTER_LIST_LOG_SUCCESS,
    UPDATE_TDP_EMPLOYEE_MASTER_LIST_LOG_FAIL,
    DELETE_TDP_EMPLOYEE_MASTER_LIST_LOG,
    DELETE_TDP_EMPLOYEE_MASTER_LIST_LOG_SUCCESS,
    DELETE_TDP_EMPLOYEE_MASTER_LIST_LOG_FAIL,
    RESET_TDP_EMPLOYEE_MASTER_LIST_LOG_DETAILS,
} from "./actionsTypes";

const initialState = {
    TDPEmployeeMasterListLogList: [],
    TDPEmployeeMasterListLogDetails: {},
    createResult: {},
    deleteResult: {},
    loading: false,
    detailsLoading: false,
    loadingCreate: false,
    error: {
        message: "",
    },
};

const TDPEmployeeMasterListLogReducer = (state = initialState, action) => {
    if (!action) return state;

    switch (action.type) {
        case TDP_EMPLOYEE_MASTER_LIST_LOG_CREATE:
            state = { ...state, createResult: {}, loadingCreate: true };
            break;
        case TDP_EMPLOYEE_MASTER_LIST_LOG_CREATE_SUCCESS:
            state = { ...state, createResult: action.payload, loadingCreate: false };
            break;
        case TDP_EMPLOYEE_MASTER_LIST_LOG_CREATE_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                createResult: {},
                loadingCreate: false,
            };
            break;

        //GET individual TDP Employee Master List Log
        case GET_TDP_EMPLOYEE_MASTER_LIST_LOG_DETAILS:
            state = { ...state, detailsLoading: true, TDPEmployeeMasterListLogDetails: {} };
            break;
        case GET_TDP_EMPLOYEE_MASTER_LIST_LOG_DETAILS_SUCCESS:
            state = { ...state, TDPEmployeeMasterListLogDetails: action.payload, detailsLoading: false };
            break;
        case GET_TDP_EMPLOYEE_MASTER_LIST_LOG_DETAILS_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                detailsLoading: false,
            };
            break;

        //Update individual TDP Employee Master List Log
        case UPDATE_TDP_EMPLOYEE_MASTER_LIST_LOG:
            state = { ...state, createResult: {}, loading: true };
            break;
        case UPDATE_TDP_EMPLOYEE_MASTER_LIST_LOG_SUCCESS:
            state = { ...state, createResult: action.payload, loading: false };
            break;
        case UPDATE_TDP_EMPLOYEE_MASTER_LIST_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false
            };
            break;

        //Delete individual TDP Employee Master List Log
        case DELETE_TDP_EMPLOYEE_MASTER_LIST_LOG:
            state = { ...state, deleteResult: {}, loading: true, };
            break;
        case DELETE_TDP_EMPLOYEE_MASTER_LIST_LOG_SUCCESS:
            state = { ...state, deleteResult: action.payload, loading: false };
            break;
        case DELETE_TDP_EMPLOYEE_MASTER_LIST_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
                deleteResult: {}
            };
            break;

        //Reset TDP Employee Master List Log
        case RESET_TDP_EMPLOYEE_MASTER_LIST_LOG_DETAILS:
            state = { ...state, TDPEmployeeMasterListLogDetails: {}, detailsLoading: false };
            break;

        case RESET:
            state = { ...state, TDPEmployeeMasterListLogList: [], createResult: {} };
            break;
        case RESET_TDP_EMPLOYEE_MASTER_LIST_LOG_CREATE:
            state = { ...state, createResult: {} };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default TDPEmployeeMasterListLogReducer;